import React, {useEffect} from "react";
import Helmet from "react-helmet";
import "../../styles/newStyles/HelpWidget.scss";
import {tenantId, chatBotId} from "config/envConfig";
import {useSelector} from "react-redux";

export const HelpWidget = () => {
  const user = useSelector((state) => state.login?.user);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (tenantId === "e7f81d33-0817-4c34-800d-b8b4ade36f2e") {
      window.BOTMAKER_VAR = {
        webChatHostDomain: window.location.hostname,
        webChatHostHREF: window.location.href,
        webChatHostReferrer: document.referrer,
        webChatHostURL: window.location.origin,
        first_name: user.firstName,
        last_name: user.lastName,
        full_name: `${user.firstName} ${user.lastName}`,
        email: user.email,
        user_uuid: user.uuid,
        fiscal_id: user.fiscalId,
        company_name: user.accountName,
        channel: 'dashboard'
      };
    }
  }, [user.firstName, user.lastName, user.uuid]);
  /* eslint-enable react-hooks/exhaustive-deps */

  let scriptElement;

  switch (tenantId) {
    case "e7f81d33-0817-4c34-800d-b8b4ade36f2e":
      scriptElement = (
        <script
          id="language-script"
          type="text/javascript"
          async
          src={`https://go.botmaker.com/rest/webchat/p/${chatBotId}/init.js`}
        ></script>
      );
      break;
    case "203c5d06-1f1b-49ef-ab38-71ed4d60db66":
      scriptElement = (
        <script
          id="ze-snippet"
          src="https://static.zdassets.com/ekr/snippet.js?key=c341a8e0-577b-42a8-875c-67c1f7588eb2"
        >
          {" "}
        </script>
      );
      break;
    default:
      scriptElement = null; // No script for other tenant IDs
  }
  return (
    <div className="help-widget">
      <Helmet>
        {scriptElement}
      </Helmet>
    </div>
  );
};
